import './footer.scss';

// Footer.tsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faSnapchat, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

import React from 'react';
import { Translate } from 'react-jhipster';
import { Col, Row } from 'reactstrap';

const Footer = () => (
  <div className="footer page-content">
    <footer className="footer-container">
      <div className="text-blocks">
        <Col md={3} sm={6}>
          <div className="text-block">
            Concepteur-Développeur :
            <br />
            <a>Sté François Yvon RAFARALAHY (Freelance)</a>
            <br />
            SIRET 88966343100019
            <br />
            92120 Montrouge - FRANCE
          </div>
        </Col>
        <Col md={3} sm={6}>
          <div className="text-block">
            &#9829; Contact :<br />
            rafaralahyf@gmail.com
            <br />
            +33 6 95 09 68 56 (France)
            <br />
            +261 (0)32 54 467 71
          </div>
        </Col>
        <Col md={3} sm={6}>
          <div className="text-block">
            Site web :
            <br />
            <a className="text_white" href="https://rafaros-it.fr/" target="_blank">
              rafaros-it.fr
            </a>
            <br />
            &copy; Copyright 2023 - Sté FYR <br />
            <Link className="text_grey" to="/policy">
              Politique de Confidentialité
            </Link>
            <br />
            <Link className="text_grey" to="/bookmarklet">
              Bookmarklet
            </Link>
          </div>
        </Col>

        <div>
          <img className="pic-of-me" src="../../../content/images/babakoto_lemurien.png" />
        </div>

        {/* <Col md={3} sm={6}>
          <div className="text-block">Bloc 4</div>
        </Col> */}
      </div>
      <div className="social-icons">
        <div className="social-icon-container">
          <a href="https://www.facebook.com/Rafaros.68" target="_blank">
            <FontAwesomeIcon icon={faFacebook} className="social-icon" />
          </a>
        </div>
        <div className="social-icon-container">
          <a href="https://twitter.com/rafarosIT" target="_blank">
            <FontAwesomeIcon icon={faTwitter} className="social-icon" />
          </a>
        </div>
        <div className="social-icon-container">
          <a href="https://www.instagram.com/franrafar/" target="_blank">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
        </div>
        <div className="social-icon-container">
          <a href="lien_vers_snapchat" target="_blank">
            <FontAwesomeIcon icon={faSnapchat} className="social-icon" />
          </a>
        </div>
        <div className="social-icon-container">
          <a href="https://www.linkedin.com/in/fran%C3%A7ois-yvon-rafaralahy-045a9ba1/" target="_blank">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          </a>
        </div>
      </div>
    </footer>
  </div>
);

export default Footer;
